var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtTargetSmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 49.258c0 .343-6.456.742-13.896.742s-13.47-.278-13.47-.621c0-.343 6.03-.621 13.47-.621S34 48.916 34 49.259z",
    fill: "#32323F",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.262.001C21.958.017 28.177 11.034 28.15 24.61c-.027 13.575-4.197 24.598-14.672 24.598C7.318 49.208.249 38.13.276 24.554.302 10.98 6.565-.014 14.262.001z",
    fill: "#7D1300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.865 24.606c-.027 13.575-5.838 24.569-12.98 24.555l-.115-.001a6.867 6.867 0 0 1-1.392-.167 7.913 7.913 0 0 1-2.494-1.04C3.707 44.739-.021 35.475 0 24.555.026 10.98 5.838-.014 12.98 0c.205 0 .408.01.61.028C20.449.65 25.89 11.42 25.863 24.606h.003z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 12.28 24.581)",
    cx: 12.28,
    cy: 24.581,
    rx: 21.724,
    ry: 11.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 11.723 24.58)",
    cx: 11.723,
    cy: 24.58,
    rx: 17.685,
    ry: 9.304
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 11.035 24.578)",
    cx: 11.035,
    cy: 24.578,
    rx: 14.345,
    ry: 7.548
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 10.576 24.578)",
    cx: 10.576,
    cy: 24.578,
    rx: 9.605,
    ry: 5.054
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 10.576 24.578)",
    cx: 10.576,
    cy: 24.578,
    rx: 4.839,
    ry: 2.546
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.758 22.82c-.283.678.581 1.4.025 2.81-.555 1.408 1.595-1.805 1.595-1.805l-.62-1.586-1 .582v-.001z",
    fill: "#CD2B31"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 16.601,
    cy: 24.67,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.889 25.04s.545-.129.542-.283c-.002-.126-.553-.199-.553-.199l-3.034.218.01.482 3.035-.217z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.052 24.595a.56.56 0 0 0-.543-.407l-3.73.136.013.294.042.934 3.73-.135c.302-.011.533-.286.518-.614l-.002-.043a.689.689 0 0 0-.03-.166l.002.001z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.78 24.325-3.801.29c-.095.002-.761.05-1.49.13-.962.107-2.031.27-2.03.462v.002c.029.337 3.342.34 3.562.332l3.813.012-.042-.934-.013-.293v-.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.256 25.105-3.884.142-.031.046-.017.024a1.607 1.607 0 0 0 .216 1.955c.283.283.642.417.993.404.353-.013.697-.172.953-.475l1.266-1.499.144-.17.36-.427z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.052 24.595a.56.56 0 0 0-.543-.407l-3.73.136-3.8.29c-.095.003-.761.051-1.49.132l-.074.184 5.377-.312 1.189-.069s2.43-.062 3.07.045v.001z",
    fill: "#1F1F39",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31 22.742c.352-.013.71.12.992.404l1.953 1.96-3.884.141c-.485-.572-.5-1.456-.014-2.03.255-.303.6-.462.953-.475z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.896 25.69a123.344 123.344 0 0 1-3.555-.397l-.017.04c-.078.206-.136.43-.175.66.453-.134.962-.115 1.624-.09.674.025 1.658.022 1.979.072l.144-.285z",
    fill: "#1F1F39",
    opacity: 0.18
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtTargetSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-target-small.2ff864326343bca0d81667a15e2a6a7b.svg";